// import 'svgxuse';
import smoothscroll from 'smoothscroll-polyfill';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import a11ycookieconsent from './a11ycookieconsent';
import 'element-closest-polyfill';

// import resolveConfig from 'tailwindcss/resolveConfig';
//
// const tailwindConfig = require('../../tailwind.config.js');
// const fullConfig = resolveConfig(tailwindConfig);
// console.log(fullConfig);

smoothscroll.polyfill();

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.data('a11ycookieconsent', a11ycookieconsent);
Alpine.start();
